import { cn } from "@/shared/lib/cn";

import { Logo } from "./Logo";

interface LogoFullProps {
  /** Pixel height of the name-logo lockup; the caption scales with it. */
  height?: number;
  className?: string;
  /** Optional accessible label override. */
  alt?: string;
  /** Lockup alignment: centered (hero) or left-aligned (page corners). */
  align?: "center" | "start";
}

const TAGLINE = "Employer Invoicing • Agent Commissions • Real Time Provider Payments";

/**
 * PayGate LogistiX hero lockup — the name logo plus the product tagline
 * ("Employer Invoicing • Agent Commissions • Real Time Provider Payments").
 * Use on hero surfaces (login). For the in-app shell keep the compact
 * `<Logo>` so the brand mark doesn't dominate working surfaces.
 */
export function LogoFull({
  height = 64,
  className,
  alt = `PayGate LogistiX — ${TAGLINE}`,
  align = "center",
}: LogoFullProps) {
  return (
    <span
      className={cn(
        "inline-flex select-none flex-col",
        align === "center" ? "items-center" : "items-start",
        className
      )}
      style={{ gap: height * 0.22 }}
      role="img"
      aria-label={alt}
    >
      <Logo height={height} alt="" />
      <span
        aria-hidden
        className={cn(
          "font-medium leading-snug text-foreground",
          align === "center" ? "text-center" : "text-left"
        )}
        style={{ fontSize: Math.max(10, height * 0.15) }}
      >
        Employer Invoicing • Agent Commissions
        <br />
        Real Time Provider Payments
      </span>
    </span>
  );
}
